export default {
    teacher: [],
    active_teacher: []
}